function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#b1c3cc",
  d: "M3.36 4.69L1.56 2.9 3 1.49l1.76 1.8zM2 11H0V9h2zm5 4.14C5.21 14.1 4 12.17 4 10c0-3.36 2.69-6 6-6s6 2.64 6 6c0 2.17-1.21 4.1-3 5.14V20H7zM11 18v-4l1-.59c1.23-.72 2-2.04 2-3.41 0-2.26-1.79-4-4-4s-4 1.74-4 4c0 1.37.76 2.69 2 3.41L9 14v4zm9-7h-2V9h2zm-9-9H9V0h2zm5.66 2.71L15.25 3.3 17 1.5l1.45 1.41z"
})));

var SvgBulb = function SvgBulb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bulb.70307f40.svg";
export { ForwardRef as ReactComponent };